import type { FC } from 'react';
import React from 'react';
import { Aligner } from '@alfa-bank/site-aligner';
import { ProgressBarV2Desktop } from '@alfa-bank/site-progress-bar-v2/desktop';
import { useSelector } from 'react-redux';

import { selectShowProgressBar } from '../../store';
import { LoadingBlockDesktop } from '../../components/loading-block/desktop';

import type { TAwaitingFnsInnIdentificationStepDesktop } from './model';
import { defaultAwaitingFnsInnIdentificationSettingsDesktop } from './config/default-values';

export const AwaitingFnsInnIdentificationStepDesktop: FC<
    TAwaitingFnsInnIdentificationStepDesktop
> = ({
    loadingText = defaultAwaitingFnsInnIdentificationSettingsDesktop.loadingText,
    progressBarSettings = defaultAwaitingFnsInnIdentificationSettingsDesktop.progressBarSettings,
    loadingIconSrc,
}) => {
    const showProgressBar = useSelector(selectShowProgressBar);

    return (
        <Aligner>
            {showProgressBar && (
                <ProgressBarV2Desktop
                    caption={progressBarSettings.caption}
                    currentStepName={progressBarSettings.currentStepName}
                    hatchValue={progressBarSettings.hatchValue}
                    header={progressBarSettings.header}
                    line={progressBarSettings.line}
                    maxStep={progressBarSettings.maxStep}
                    nextStepName={progressBarSettings.nextStepName}
                    steps={progressBarSettings.steps}
                    styler={{ marginBottom: 32 }}
                    value={progressBarSettings.value}
                />
            )}
            <Aligner>
                <LoadingBlockDesktop loadingIconSrc={loadingIconSrc} loadingText={loadingText} />
            </Aligner>
        </Aligner>
    );
};
